import { getPartnersAction } from "../redux/Reducers/partnersReducer";
import { BASE_URL } from "./BASE_URL";

export const getPartners = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + "partners/?limit=550");
    const data = await response.json();

    if (response.status === 200) {
      dispatch(getPartnersAction(data.results));
    }
  };
};
